export default __webpack_public_path__ + "static/media/Player.c0c19cb5.svg";